import { Type } from 'class-transformer';
import { UserDto } from './user.dto';

export enum AuditEntityType {
  COMPANY = 'company',
  MEDIA = 'media',
  PAYORDER = 'payorder',
  PURCHASE = 'purchase',
  LEAD = 'lead',
  INVOICE = 'invoice',
  USER = 'user',
  CONTRACT = 'contract',
  LEGAL_ENTITY = 'legal-entity',
}

export enum AuditAction {
  COMPANY_CREATED = 'company.created',
  COMPANY_RENAMED = 'company.renamed',
  COMPANY_MANAGER_LINKED = 'company.manager.linked',
  COMPANY_MANAGER_UNLINKED = 'company.manager.unlinked',
  COMPANY_LEAD_LINKED = 'company.lead.linked',

  CONTRACT_UPDATED = 'contract.updated',

  LEGAL_ENTITY_UPDATED = 'legal-entity.updated',

  MEDIA_CREATED = 'media.created',
  MEDIA_UPDATED = 'media.updated',

  PAYORDER_CREATED = 'payorder.created',
  PAYORDER_UPDATED = 'payorder.updated',
  PAYORDER_STATUS_CHANGED = 'payorder.status.changed',

  PURCHASE_CREATED = 'purchase.created',
  PURCHASE_STATUS_CHANGED = 'purchase.status.changed',
  PURCHASE_WCC_AUTOMATION_FAILED = 'purchase.wcc.automation.failed',

  LEAD_CREATED = 'lead.created',
  LEAD_UPDATED = 'lead.updated',
  LEAD_MANAGER_CHANGED = 'lead.manager.changed',
  LEAD_MEDIAPLAN_UPDATED = 'lead.mediaplan.updated',
  LEAD_DELETED = 'lead.deleted',
  LEAD_RESTORED = 'lead.restored',
  LEAD_CONTACT_CREATED = 'lead.contact.created',
  LEAD_CONTACT_UPDATED = 'lead.contact.updated',
  LEAD_CONTACT_DELETED = 'lead.contact.deleted',
  LEAD_CONTACT_RESTORED = 'lead.contact.restored',
  LEAD_COMMENT_CREATED = 'lead.comment.created',
  LEAD_COMMENT_UPDATED = 'lead.comment.updated',
  LEAD_COMMENT_DELETED = 'lead.comment.deleted',
  LEAD_COMMENT_RESTORED = 'lead.comment.restored',
  LEAD_EVENT_CREATED = 'lead.event.created',
  LEAD_EVENT_UPDATED = 'lead.event.updated',
  LEAD_EVENT_DELETED = 'lead.event.deleted',
  LEAD_EVENT_RESTORED = 'lead.event.restored',
  LEAD_STATUS_CHANGED = 'lead.status.changed',
  LEAD_COMPANY_LINKED = 'lead.company.linked',

  INVOICE_CREATED = 'invoice.created',
  INVOICE_UPDATED = 'invoice.updated',

  USER_UPDATED = 'user.updated',
}

export type LegacyAuditLogPayload = Record<string, any>;

export type AuditActorPayload = {
  id?: number;
  name?: string;
  firstName?: string;
  secondName?: string;
};

export type NormalizedAuditPayload = {
  actor?: AuditActorPayload;
  entity: {
    id: number;
    type: AuditEntityType;
  };
  data?: Record<string, any>;
};

export type AuditLogPayload = LegacyAuditLogPayload | NormalizedAuditPayload;

export class AuditLogDto {
  id: number;
  entityType: AuditEntityType;
  entityId: number;
  action: AuditAction;
  payload?: AuditLogPayload;

  @Type(() => Date)
  createdAt: Date;

  @Type(() => UserDto)
  user?: UserDto;
}

export class CreateAuditLogDto {
  entityType: AuditEntityType;
  entityId: number;
  action: AuditAction;
  payload?: AuditLogPayload;
  userId: number;
}

// Also recognises legacy generated comments that were stored as user comments.
export const LEAD_SERVICE_COMMENT_PATTERN = '^(Пользователь .+ изменил (статус|менеджера) |Автоперевод в статус |Лид закрыт автоматически, |Лид привязан к нескольким компаниям, невозможно назначить менеджера$|У этого менеджера нет добавленного номера в Wazzup[.]$)';
export const isLeadServiceComment = (record?: { content?: string }, manual = false): boolean =>
  !manual && typeof record?.content === 'string' && new RegExp(LEAD_SERVICE_COMMENT_PATTERN).test(record.content);
